export default __webpack_public_path__ + "static/media/regalxReal05_downloadMT4.fea3da78.png";